<template>
	<my-dialog :visible.sync="showDialog" title="出入库记录" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<div v-loading="loading" class="item_info border_Green" element-loading-text="加载中...">
			<el-descriptions class="margin-top" title="库存商品信息" :column="4" border>
				<el-descriptions-item label="所属门店">{{ storeProductInfo.storeName }}</el-descriptions-item>
				<el-descriptions-item label="商品类型">{{ storeProductInfo.productInfo.typeName }}</el-descriptions-item>
				<el-descriptions-item label="商品名称">{{ storeProductInfo.productInfo.productName }}</el-descriptions-item>
				<el-descriptions-item label="规格">{{ storeProductInfo.productInfo.specification }}</el-descriptions-item>
				<el-descriptions-item label="价格(元)">{{ storeProductInfo.price }}</el-descriptions-item>
				<el-descriptions-item label="库存数量">{{ storeProductInfo.quantity }}</el-descriptions-item>
				<el-descriptions-item label="成本(元)">{{ storeProductInfo.costMoney }}</el-descriptions-item>
				<el-descriptions-item label="单位">{{ storeProductInfo.productInfo.unit }}</el-descriptions-item>
				<el-descriptions-item label="是否修改库存">
					<el-tag v-if="storeProductInfo.isEditQty" type="success">是</el-tag>
					<el-tag v-else type="danger">否</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="修改库存人">{{ storeProductInfo.editQtyUserName }}</el-descriptions-item>
				<el-descriptions-item label="修改库存时间">{{ storeProductInfo.editQtyTime }}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="selectContent">
			<el-radio-group v-model.number="selectType" @input="handleInputChange">
				<el-radio-button :label="1">入库记录</el-radio-button>
				<el-radio-button :label="2">出库记录</el-radio-button>
				<el-radio-button :label="3">调拨入库</el-radio-button>
				<el-radio-button :label="4">调拨出库</el-radio-button>
			</el-radio-group>
		</div>
		<div>
			<inputRecord ref="inputRecord"></inputRecord>
			<outputRecord ref="outputRecord"></outputRecord>
			<transferInputRecord ref="transferInputRecord"></transferInputRecord>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script>
import inputRecord from "./inputRecord.vue";
import outputRecord from "./outputRecord.vue";
import transferInputRecord from "./transferInputRecord.vue";
import { GetStoreProductDetail } from "@/api/productApi.js";
export default {
	data() {
		return {
			selectType: 1,
			showDialog: false,
			loading: false,
			keyId: "",
			productTypeKeyId: "",
			storeProductInfo: {
				productInfo: {
					typeName: "",
					productName: "",
					specfication: "",
					unit: ""
				},
				price: 0,
				quantity: 0
			}
		};
	},
	// 注册组件
	components: {
		inputRecord,
		outputRecord,
		transferInputRecord
	},
	created() {},
	computed: {},
	methods: {
		showRecordDialog(row) {
			this.showDialog = true;
			this.selectType = 1;
			this.keyId = row.keyId;
			this.productTypeKeyId = row.productTypeKeyId;
			this.getStoreProductDetail();
			this.$nextTick(() => {
				this.handleInputChange(1);
			});
		},
		handleInputChange(val) {
			this.selectType = val;
			if (val == 1) {
				this.$refs.inputRecord.showInputRecordDialog(this.keyId, this.productTypeKeyId);
				this.$refs.outputRecord.closeOutputDialog();
				this.$refs.transferInputRecord.closeTransferInputRecordDialog();
			} else if (val == 2) {
				this.$refs.inputRecord.closeInputRecordDialog();
				this.$refs.outputRecord.showOutputDialog(this.keyId);
				this.$refs.transferInputRecord.closeTransferInputRecordDialog();
			} else if (val == 3) {
				this.$refs.inputRecord.closeInputRecordDialog();
				this.$refs.outputRecord.closeOutputDialog();
				this.$refs.transferInputRecord.showTransferInputRecordDialog(this.keyId, 2);
			} else if (val == 4) {
				this.$refs.inputRecord.closeInputRecordDialog();
				this.$refs.outputRecord.closeOutputDialog();
				this.$refs.transferInputRecord.showTransferInputRecordDialog(this.keyId, 3);
			}
		},
		closeDialog() {
			this.$refs.inputRecord.closeInputRecordDialog();
			this.$refs.outputRecord.closeOutputDialog();
			this.$refs.transferInputRecord.closeTransferInputRecordDialog();
			this.keyId = "";
			this.showDialog = false;
		},
		getStoreProductDetail() {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			GetStoreProductDetail({
				keyId: this.keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.storeProductInfo = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.storeProductInfo = {
				productInfo: {
					typeName: "",
					productName: "",
					specfication: "",
					unit: ""
				},
				price: 0,
				quantity: 0
			};
		}
	}
};
</script>

<style scoped>
.selectContent {
	margin-top: 20rpx;
	display: flex;
	justify-content: center;
	align-items: center;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.border_Green {
	border-left: 5px solid #00cc66;
}
</style>
